import { Controller } from "@hotwired/stimulus"
import TomSelect from "@lib/custom-tom-select"
import { get, post } from "@lib/requests"

// Connects to data-controller="animal-condition-form"
export default class extends Controller {

  static targets = ["condition", "treatment"]
  
  connect() {
    // Destroy existing Tom Select instance if it exists (e.g., from previous connection)
    if (this.conditionTarget.tomselect) {
      this.conditionTarget.tomselect.destroy()
    }

    this.conditionSelect = new TomSelect(this.conditionTarget, 
      { 
        create: this.createCondition.bind(this),
        onItemAdd: this.onConditionChange.bind(this)
      })
  }

  disconnect() {
    if (this.conditionSelect) {
      this.conditionSelect.destroy()
    }
  }

  async createCondition(input, callback) {
    try {
    const response = await post("/api/v1/conditions", { body: { name: input } })
    if (!response.ok) throw new Error(`Create failed with status ${response.status}`)
    const data = await response.json
    callback({ id: data.id, name: data.name })
    } catch (error) {
      console.error(error)
      callback()
    }
  }

  async onConditionChange(value, _item) {
    if (value) {
      try {
        const response = await get(`/api/v1/conditions/${value}`)
        if (!response.ok) throw new Error(`Get failed with status ${response.status}`)
        const condition = await response.json
        if (condition?.treatment) {
          this.treatmentTarget.value = condition.treatment
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
  
}
